import PropTypes from "prop-types";
import { useRef, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import CardContent from "@mui/material/CardContent";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Stack from "@mui/material/Stack";
// import Tab from "@mui/material/Tab";
// import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// project imports
// import ProfileTab from "./ProfileTab";
// import SettingTab from "./SettingTab";
import Avatar from "components/@extended/Avatar";
import MainCard from "components/MainCard";
import Transitions from "components/@extended/Transitions";
import IconButton from "components/@extended/IconButton";

// assets
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
// import SettingOutlined from "@ant-design/icons/SettingOutlined";
// import UserOutlined from "@ant-design/icons/UserOutlined";
import avatar1 from "assets/images/users/avatar-1.png";
import { useDispatch, useSelector } from "react-redux";
import auth from "../../../../../redux/actions/auth";
import { useNavigate } from "react-router";
import { persistor } from "../../../../../redux/store";

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`profile-tabpanel-${index}`}
			aria-labelledby={`profile-tab-${index}`}
			{...other}
		>
			{value === index && children}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `profile-tab-${index}`,
		"aria-controls": `profile-tabpanel-${index}`,
	};
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function Profile() {
	const theme = useTheme();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const user = useSelector((state) => state.auth.user);

	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);
	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};

	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleLogout = async () => {
		dispatch(auth.logout());
		await persistor.purge();
		navigate("/");
	};

	return (
		<Box sx={{ flexShrink: 0, ml: "auto" }}>
			<Tooltip title="Profile" disableInteractive>
				<ButtonBase
					sx={(theme) => ({
						p: 0.25,
						borderRadius: 1,
						"&:focus-visible": {
							outline: `2px solid ${theme.vars.palette.secondary.dark}`,
							outlineOffset: 2,
						},
					})}
					aria-label="open profile"
					ref={anchorRef}
					aria-controls={open ? "profile-grow" : undefined}
					aria-haspopup="true"
					onClick={handleToggle}
				>
					<Avatar
						alt="profile user"
						src={avatar1}
						size="sm"
						sx={{ "&:hover": { outline: "1px solid", outlineColor: "primary.main" } }}
					/>
				</ButtonBase>
			</Tooltip>
			<Popper
				placement="bottom-end"
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
				popperOptions={{
					modifiers: [
						{
							name: "offset",
							options: {
								offset: [0, 9],
							},
						},
					],
				}}
			>
				{({ TransitionProps }) => (
					<Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
						<Paper
							sx={(theme) => ({
								boxShadow: theme.vars.customShadows.z1,
								width: 290,
								minWidth: 240,
								maxWidth: { xs: 250, md: 290 },
							})}
						>
							<ClickAwayListener onClickAway={handleClose}>
								<MainCard elevation={0} border={false} content={false}>
									<CardContent sx={{ px: 2.5, pt: 3 }}>
										<Grid container sx={{ justifyContent: "space-between", alignItems: "center" }}>
											<Grid>
												<Stack direction="row" sx={{ gap: 1.25, alignItems: "center" }}>
													<Avatar alt="profile user" src={avatar1} sx={{ width: 32, height: 32 }} />
													<Stack>
														<Typography variant="h6">
															{user && user?.firstname && user?.lastname
																? user?.firstname + " " + user?.lastname
																: ""}
														</Typography>
														<Typography variant="body2" color="text.secondary">
															{user ? user?.email : ""}
														</Typography>
													</Stack>
												</Stack>
											</Grid>
											<Grid>
												<Tooltip title="Logout">
													<IconButton
														size="large"
														onClick={handleLogout}
														sx={{ color: "text.primary" }}
													>
														<LogoutOutlined />
													</IconButton>
												</Tooltip>
											</Grid>
										</Grid>
									</CardContent>

									<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
										{/* <Tabs
											variant="fullWidth"
											value={value}
											onChange={handleChange}
											aria-label="profile tabs"
										> */}
										{/* <Tab
												sx={{
													display: "flex",
													flexDirection: "row",
													justifyContent: "center",
													alignItems: "center",
													textTransform: "capitalize",
													gap: 1.25,
													"& .MuiTab-icon": {
														marginBottom: 0,
													},
												}}
												icon={<UserOutlined />}
												label="Profile"
												{...a11yProps(0)}
											/> */}
										{/* <Tab
												sx={{
													display: "flex",
													flexDirection: "row",
													justifyContent: "center",
													alignItems: "center",
													textTransform: "capitalize",
													gap: 1.25,
													"& .MuiTab-icon": {
														marginBottom: 0,
													},
												}}
												icon={<SettingOutlined />}
												label="Setting"
												{...a11yProps(1)}
											/> */}
										{/* </Tabs> */}
									</Box>
									{/* <TabPanel value={value} index={0} dir={theme.direction}>
										<ProfileTab />
									</TabPanel> */}
									{/* <TabPanel value={value} index={1} dir={theme.direction}>
										<SettingTab />
									</TabPanel> */}
								</MainCard>
							</ClickAwayListener>
						</Paper>
					</Transitions>
				)}
			</Popper>
		</Box>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	value: PropTypes.number,
	index: PropTypes.number,
	other: PropTypes.any,
};
